import s from "../../pages/info-page/styles.module.css";

export function MarkerIcon ({styleSVG}) {
    return (
      <svg className={s[`${styleSVG}`]} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.3027 10C21.3027 17 12.3027 23 12.3027 23C12.3027 23 3.30273 17 3.30273 10C3.30273 7.61305 4.25095 5.32387 5.93877 3.63604C7.6266 1.94821 9.91579 1 12.3027 1C14.6897 1 16.9789 1.94821 18.6667 3.63604C20.3545 5.32387 21.3027 7.61305 21.3027 10Z" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.3027 13C13.9596 13 15.3027 11.6569 15.3027 10C15.3027 8.34315 13.9596 7 12.3027 7C10.6459 7 9.30273 8.34315 9.30273 10C9.30273 11.6569 10.6459 13 12.3027 13Z" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
}